import { useEffect, useId, useState } from "react";
import "../styles/components/Pagination.css";

export const Pagination = ({ currentPage, totalPages, handlePageChange }) => {
  const [pageInput, setPageInput] = useState(String(currentPage));
  const pageInputId = useId();

  useEffect(() => {
    setPageInput(String(currentPage));
  }, [currentPage, totalPages]);

  const handlePageSubmit = (event) => {
    event.preventDefault();
    const pageNumber = Number(pageInput);
    if (
      pageInput.trim() !== "" &&
      Number.isInteger(pageNumber) &&
      pageNumber >= 1 &&
      pageNumber <= totalPages &&
      pageNumber !== currentPage
    ) {
      handlePageChange(pageNumber);
    }
  };

  return (
    <nav className="pagination" aria-label="Pagination">
      <button
        type="button"
        onClick={() => handlePageChange(currentPage - 1)}
        disabled={currentPage <= 1 || totalPages < 1}
        className="pagination__btn pagination__btn--prev"
      >
        Previous
      </button>

      <div className="pagination__numbers">
        {[...Array(totalPages)].map((_, index) => {
          const pageNumber = index + 1;

          if (
            pageNumber === 1 ||
            pageNumber === totalPages ||
            (pageNumber >= currentPage - 1 && pageNumber <= currentPage + 1)
          ) {
            return (
              <button
                key={pageNumber}
                type="button"
                aria-label={`Page ${pageNumber}`}
                aria-current={currentPage === pageNumber ? "page" : undefined}
                onClick={() => handlePageChange(pageNumber)}
                className={`pagination__number ${
                  currentPage === pageNumber ? "pagination__number--active" : ""
                }`}
              >
                {pageNumber}
              </button>
            );
          } else if (
            pageNumber === currentPage - 2 ||
            pageNumber === currentPage + 2
          ) {
            return (
              <span key={pageNumber} className="pagination__dots">
                •••
              </span>
            );
          }
          return null;
        })}
      </div>

      <button
        type="button"
        onClick={() => handlePageChange(currentPage + 1)}
        disabled={currentPage >= totalPages}
        className="pagination__btn pagination__btn--next"
      >
        Next
      </button>
      <form className="pagination__jump" onSubmit={handlePageSubmit}>
        <label htmlFor={pageInputId}>Go to page</label>
        <input
          id={pageInputId}
          className="pagination__input"
          type="number"
          inputMode="numeric"
          min="1"
          max={totalPages}
          step="1"
          required
          value={pageInput}
          onChange={(event) => setPageInput(event.target.value)}
          disabled={totalPages < 1}
        />
        <span className="pagination__total">of {totalPages}</span>
        <button
          type="submit"
          className="pagination__btn pagination__btn--go"
          disabled={totalPages < 1}
        >
          Go
        </button>
      </form>
    </nav>
  );
};
